import Cow from '@assets/svg/cow.svg?react';

type CattleIconProps = {
  className?: string;
};

export function CattleIcon({ className }: CattleIconProps) {
  return <Cow aria-hidden="true" className={className} focusable="false" />;
}
